<div class="w-full bg-primary h-9 flex items-center justify-between">
    <label class="text-white pl-2 text-lg">Integration Manager</label>
    <mat-icon (click)="closeDialog()" class="text-white cursor-pointer mr-2">close</mat-icon>
</div>


<div class="p-6">
    <h2 class="text-xl font-semibold mb-4">Clone Integration</h2>
    <form [formGroup]="form">
        <div class="grid gap-4">
            <div class="flex flex-wrap custom-form-field-container">
                <label class="block mb-2 text-sm font-medium text-gray-900">Source Customer</label>
                <mat-form-field class="w-full h-10">
                    <input onfocus="this.select()" type="text" aria-label="Number" matInput
                        formControlName="sourceCustomer" [matAutocomplete]="autoSourceCustomer" />
                    <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                    <mat-autocomplete autoActiveFirstOption #autoSourceCustomer="matAutocomplete"
                        [displayWith]="displayFnCustomer.bind(this)"
                        (optionSelected)="onSourceCustomerSelected($event)">
                        @for (option of filteredSourceOptions | async; track option) {
                        <mat-option [value]="option">{{ option.id }} - {{ option.name }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="flex flex-wrap custom-form-field-container">
                <label class="block mb-2 text-sm font-medium text-gray-900">Integration Profile</label>
                <mat-form-field class="w-full h-10">
                    <input onfocus="this.select()" type="text" aria-label="Number" matInput
                        formControlName="integrationProfile" [matAutocomplete]="autoIntegrationProfile" />
                    <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                    <mat-autocomplete autoActiveFirstOption #autoIntegrationProfile="matAutocomplete"
                        [displayWith]="displayFnIntegration.bind(this)">
                        @for (option of filteredIntegrationOptions | async; track option) {
                        <mat-option [value]="option">{{ option?.id }} - {{ option?.pms }} - {{ option?.type?.name
                            }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="flex flex-wrap custom-form-field-container">
                <label class="block mb-2 text-sm font-medium text-gray-900">Target customer IDs</label>
                <mat-form-field class="w-full h-10">
                    <input onfocus="this.select()" type="text" aria-label="Target customer IDs" matInput
                        formControlName="targetCustomerIds"
                        placeholder="e.g. 6, 7, 30" />
                </mat-form-field>
            </div>
        </div>

        <div class="flex justify-end dialog-footer pt-5">
            <button type="submit" id="save-button-integration" (click)="onSubmit()" [disabled]="!form.valid"
                class="text-white bg-primary focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center">Clone</button>
        </div>
    </form>
</div>